<div class="w-full h-full pb-20 bg-slate-50/50 font-sans mx-auto overflow-auto relative">

  <!------------------------------ Curved Header with Premium Gradient ------------------------------>
  <div
    class="absolute top-0 left-0 right-0 h-[220px] bg-gradient-to-r from-(--main-color) to-(--soft-color) rounded-b-[2.5rem] shadow-md z-0 transition-all duration-300">
  </div>

  <!---------------------------------------- Header Navigation & Title ---------------------------------->
  <div class="relative z-10 flex-none px-4 pt-4 pb-2">
    <div class="flex items-center justify-between">
      <button (click)="goback()"
        class="w-10 h-10 bg-white/95 backdrop-blur-sm rounded-full shadow-md flex items-center justify-center text-slate-700 hover:text-amber-500 active:scale-95 transition-all">
        <img src="icons/arrow_back_black.svg" />
      </button>
      <h1 class="text-lg font-extrabold text-slate-800 tracking-wide">
        {{ currentLang === "TH" ? "ประวัติการชำระเงิน" : "Payment History" }}
      </h1>
      <div class="w-10"></div>
    </div>
  </div>

  <!---------------------------------------- Original Bill Icon Header Graphic ------------------------------>
  <div class="relative flex flex-col items-center pb-4 pt-1 z-10 flex-none">
    <div class="p-2 bg-white rounded-full shadow-lg shadow-gray-200/50 flex items-center justify-center">
      <div class="w-[72px] h-[72px] p-3.5 bg-white shadow rounded-full">
        <img src="icons/Payment-history/bill.png" alt="bill" class="w-full h-full object-contain drop-shadow-sm" />
      </div>
    </div>
  </div>

  <!---------------------------------------- Main Scrollable Content Area ---------------------------------->
  <div class="relative z-10 flex-1  custom-scrollbar flex flex-col pb-6">
    <div class="px-4 space-y-4">

      <!-------------------------------- Date Selection & Search Panel ---------------------------------->
      <div class="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl border border-slate-100/50 p-4">
        <div class="flex flex-col gap-4">
          <div class="grid grid-cols-2 gap-3">

            <!-- Start Date Picker -->
            <div class="space-y-1">
              <label class="block text-xs font-bold text-slate-500 pl-1">
                {{ currentLang === "TH" ? "เริ่มต้น" : "Start Date"}}
              </label>
              <div class="relative">
                <input matInput [matDatepicker]="startPicker" [max]="endDate || today" [min]="minStartDate"
                  [(ngModel)]="startDate" readonly placeholder="DD/MM/YYYY"
                  class="w-full bg-slate-50/80 border border-slate-200 text-sm rounded-xl pl-3 pr-10 py-2.5 text-slate-800 outline-none focus:bg-white focus:border-(--main-color) focus:ring-2 focus:ring-(--main-color)/30 transition-all placeholder:text-slate-300 cursor-pointer"
                  (click)="startPicker.open()" />
                <mat-datepicker-toggle matSuffix [for]="startPicker"
                  class="absolute top-1/2 right-1 -translate-y-1/2 scale-90"></mat-datepicker-toggle>
                <mat-datepicker #startPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
              </div>
            </div>

            <!-- End Date Picker -->
            <div class="space-y-1">
              <label class="block text-xs font-bold text-slate-500 pl-1">
                {{ currentLang === "TH" ? "สิ้นสุด" : "End Date"}}
              </label>
              <div class="relative">
                <input matInput [matDatepicker]="endPicker" [max]="today" [min]="startDate || minStartDate"
                  [(ngModel)]="endDate" readonly placeholder="DD/MM/YYYY"
                  class="w-full bg-slate-50/80 border border-slate-200 text-sm rounded-xl pl-3 pr-10 py-2.5 text-slate-800 outline-none focus:bg-white focus:border-(--main-color) focus:ring-2 focus:ring-(--main-color)/30 transition-all placeholder:text-slate-300 cursor-pointer"
                  (click)="endPicker.open()" />
                <mat-datepicker-toggle matSuffix [for]="endPicker"
                  class="absolute top-1/2 right-1 -translate-y-1/2 scale-90"></mat-datepicker-toggle>
                <mat-datepicker #endPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
              </div>
            </div>

          </div>

          <!-- Green Action Button matching application style standard -->
          <button (click)="searchPaymentHistory()"
            class="w-full bg-gradient-to-r from-(--main-color) to-(--soft-color) text-slate-800 font-extrabold py-2.5 rounded-xl shadow-lg shadow-(--main-color)/20 active:scale-[0.98] transition-all flex justify-center items-center gap-2">
            <img src="icons/search_black.svg" class="w-5 h-5" />
            <span>{{ currentLang === "TH" ? "ดึงข้อมูลประวัติ" : "Fetch History"}}</span>
          </button>
        </div>
      </div>

      <!-------------------------------- Interactive Control Center ---------------------------------->
      <div class="flex gap-2">
        <button (click)="toggleDashboard()"
          [ngClass]="showDashboard ? 'bg-gradient-to-r from-(--main-color) to-(--soft-color) text-slate-800 shadow-md shadow-(--main-color)/20 font-extrabold' : 'bg-white text-slate-600 border border-slate-100'"
          class="flex-1 py-2 rounded-xl text-xs font-bold transition-all flex items-center justify-center gap-1.5 active:scale-95">
          <img src="icons/monitoring_black.svg" />
          <span>{{ currentLang === "TH" ? "แดชบอร์ดสรุป" : "Dashboard" }}</span>
        </button>
        <button (click)="toggleFilters()"
          [ngClass]="showTableFilters ? 'bg-gradient-to-r from-(--main-color) to-(--soft-color) text-slate-800 shadow-md shadow-(--main-color)/20 font-extrabold' : 'bg-white text-slate-600 border border-slate-100'"
          class="flex-1 py-2 rounded-xl text-xs font-bold transition-all flex items-center justify-center gap-1.5 active:scale-95">
          <img src="icons/filter_list_black.svg" />
          <span>{{ currentLang === "TH" ? "ตัวกรองขั้นสูง" : "Filters" }}</span>
          <span *ngIf="searchQuery || selectedSite || selectedFeeType"
            class="w-1.5 h-1.5 rounded-full bg-red-500 animate-ping"></span>
        </button>
      </div>

      <!-------------------------------- dynamic stats dashboard ---------------------------------->
      <div *ngIf="showDashboard"
        class="bg-white/95 backdrop-blur-sm border border-slate-100/50 rounded-2xl p-4 shadow-xl animate-fade-in-up">
        <div class="flex items-center gap-2 mb-3">
          <div class="w-1.5 h-4 bg-(--main-color) rounded-full"></div>
          <span class="text-xs font-bold text-slate-700 uppercase tracking-wide">
            {{ currentLang === "TH" ? "สถิติการใช้งานในช่วงเวลา" : "Usage Overview Statistics" }}
          </span>
        </div>
        <div class="grid grid-cols-4 gap-2">

          <!-- Stat 1: Total Payments -->
          <div
            class="group flex flex-col items-center bg-slate-50/50 rounded-xl p-2 transition-all hover:bg-slate-50 border border-slate-100/30">
            <div
              class="w-8 h-8 p-1 rounded-full bg-(--main-color)/15 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
              <img src="icons/receipt_long_black.svg" />
            </div>
            <span class="text-sm font-extrabold text-slate-800">{{ totalPayments }}</span>
            <span class="text-[9px] font-bold text-slate-400 mt-0.5">{{ currentLang === "TH" ? "จำนวนครั้ง" : "Payments"
              }}</span>
          </div>

          <!-- Stat 2: Total Amount -->
          <div
            class="group flex flex-col items-center bg-slate-50/50 rounded-xl p-2 transition-all hover:bg-slate-50 border border-slate-100/30">
            <div
              class="w-8 h-8 rounded-full bg-(--main-color)/15 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
              <img src="icons/payments_black.svg" />
            </div>
            <span class="text-sm font-extrabold text-slate-800">{{ totalAmount | number: '1.0-0' }}</span>
            <span class="text-[9px] font-bold text-slate-400 mt-0.5">{{ currentLang === "TH"
              ? "ยอดรวม (฿)"
              : "Total (฿)"
              }}</span>
          </div>

          <!-- Stat 3: Avg Amount -->
          <div
            class="group flex flex-col items-center bg-slate-50/50 rounded-xl p-2 transition-all hover:bg-slate-50 border border-slate-100/30">
            <div
              class="w-8 h-8 p-1 rounded-full bg-(--main-color)/15 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
              <img src="icons/calculate_black.svg" />
            </div>
            <span class="text-sm font-extrabold text-slate-800">{{ averageAmount | number: '1.0-0' }}</span>
            <span class="text-[9px] font-bold text-slate-400 mt-0.5">{{ currentLang === "TH" ? "เฉลี่ย (฿)" : "Avg (฿)"
              }}</span>
          </div>

          <!-- Stat 4: Visited Sites -->
          <div
            class="group flex flex-col items-center bg-slate-50/50 rounded-xl p-2 transition-all hover:bg-slate-50 border border-slate-100/30">
            <div
              class="w-8 h-8 p-1 rounded-full bg-(--main-color)/15 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
              <img src="icons/domain_black.svg" />
            </div>
            <span class="text-sm font-extrabold text-slate-800">{{ uniqueSitesCount }}</span>
            <span class="text-[9px] font-bold text-slate-400 mt-0.5">{{ currentLang === "TH" ? "จุดบริการ" : "Sites"
              }}</span>
          </div>

        </div>
      </div>

      <!-------------------------------- Advanced Filter Panel ---------------------------------->
      <div *ngIf="showTableFilters"
        class="bg-white rounded-2xl border border-slate-100 p-4 shadow-lg space-y-4 animate-fade-in-up">
        <!-- Filter Header with Reset -->
        <div class="flex justify-between items-center">
          <span class="text-xs font-bold text-slate-700">
            {{ currentLang === "TH" ? "ค้นหาและกรองข้อมูล" : "Search & Filtering Options" }}
          </span>
          <button *ngIf="searchQuery || selectedSite || selectedFeeType"
            (click)="searchQuery = ''; selectedSite = ''; searchFieldText = ''; selectedFeeType = ''"
            class="text-xs font-bold text-amber-600 hover:text-amber-700 transition-colors flex items-center gap-0.5 active:scale-95">
            <img src="icons/restart_alt_orange_dark.svg" class="w-4 h-4" />
            <span>{{ currentLang === "TH" ? "รีเซ็ตตัวกรอง" : "Reset" }}</span>
          </button>
        </div>

        <!-- Search input for License Plate / Receipt ID -->
        <div class="space-y-1">
          <label class="block text-xs font-bold text-slate-500 pl-1">
            {{ currentLang === "TH" ? "ค้นหาด้วยเลขทะเบียนรถ หรือเลขที่ใบเสร็จ" : "Search License Plate / Receipt No."
            }}
          </label>
          <div class="relative">
            <div class=" absolute left-3 top-1/2 -translate-y-1/2">
              <img src="icons/search_slate_dark.svg" class="w-4 h-4" />
            </div>
            <input type="text" [(ngModel)]="searchQuery"
              placeholder="{{ currentLang === 'TH' ? 'พิมพ์คำค้นหา...' : 'Type to search...' }}"
              class="w-full bg-slate-50/50 border border-slate-200 text-sm rounded-xl pl-10 pr-4 py-2 text-slate-800 outline-none focus:bg-white focus:border-(--main-color) focus:ring-2 focus:ring-(--main-color)/30 transition-all placeholder:text-slate-300" />
          </div>
        </div>

        <!-- Searchable Autocomplete Dropdown (Combo Box) for Site Name -->
        <div class="space-y-1">
          <label class="block text-xs font-bold text-slate-500 pl-1">
            {{ currentLang === "TH" ? "สถานที่ / จุดบริการ" : "Site Name" }}
          </label>
          <div class="relative">
            <div class="absolute left-3 top-1/2 -translate-y-1/2">
              <img src="icons/domain_slate_dark.svg" class="w-4 h-4" />
            </div>
            <input type="text" [(ngModel)]="searchFieldText" (focus)="isSiteDropdownOpen = true"
              (blur)="closeDropdowns()"
              placeholder="{{ currentLang === 'TH' ? 'พิมพ์ค้นหาสถานที่...' : 'Type to search site...' }}"
              class="w-full bg-slate-50/50 border border-slate-200 text-sm rounded-xl pl-10 pr-10 py-2 text-slate-800 outline-none focus:bg-white focus:border-(--main-color) focus:ring-2 focus:ring-(--main-color)/30 transition-all placeholder:text-slate-300" />
            <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none transition-transform duration-300"
              [ngClass]="{'rotate-180': isSiteDropdownOpen}">
              <img src="icons/expand_more_slate_dark.svg" />
            </div>

            <!-- Fake Dropdown Menu Options -->
            <div *ngIf="isSiteDropdownOpen && filteredSiteOptions.length > 0" (mousedown)="$event.preventDefault()"
              class="absolute z-30 left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-white border border-slate-100 rounded-xl shadow-2xl custom-scrollbar">
              <div *ngFor="let site of filteredSiteOptions" (click)="selectSite(site)"
                [ngClass]="selectedSite === site ? 'bg-amber-50 text-amber-700 font-bold' : 'hover:bg-slate-50 text-slate-700'"
                class="px-4 py-2.5 text-sm cursor-pointer transition-colors flex items-center justify-between">
                <span>{{ site }}</span>
                <img *ngIf="selectedSite === site" src="icons/check_orange.svg" class="w-4 h-4" />
              </div>
            </div>
          </div>
        </div>

        <!-- Payment Type Filter Chips -->
        <div class="space-y-1.5" *ngIf="feeTypeOptions.length > 0">
          <label class="block text-xs font-bold text-slate-500 pl-1">
            {{ currentLang === "TH" ? "ประเภทค่าบริการ" : "Payment Type" }}
          </label>
          <div class="flex flex-wrap gap-1.5 pb-1">
            <button (click)="selectedFeeType = ''"
              [ngClass]="!selectedFeeType ? 'bg-(--main-color)/15 text-slate-800 border-(--main-color)/40 font-bold' : 'bg-slate-50 text-slate-600 border-slate-200'"
              class="px-3 py-1 rounded-full text-xs border transition-all active:scale-95">
              {{ currentLang === "TH" ? "ทั้งหมด" : "All" }}
            </button>
            <button *ngFor="let type of feeTypeOptions" (click)="selectFeeType(type)"
              [ngClass]="selectedFeeType === type ? 'bg-(--main-color)/15 text-slate-800 border-(--main-color)/40 font-bold' : 'bg-slate-50 text-slate-600 border-slate-200'"
              class="px-3 py-1 rounded-full text-xs border transition-all active:scale-95">
              {{ type }}
            </button>
          </div>
        </div>

      </div>

      <!-------------------------------- Payment History Cards list ---------------------------------->
      <div class="space-y-4">

        <!-- Tickets -->
        <div *ngFor="let payment of filteredPaymentHistory"
          class="bg-white rounded-2xl shadow-md border border-slate-100 overflow-hidden animate-fade-in-up transition-all hover:shadow-lg">
          <!-- Card Header (Site Name & Type badge styled with main and soft gradient) -->
          <div
            class="bg-gradient-to-r from-(--main-color) to-(--soft-color) px-4 py-3 border-b border-slate-100/50 flex justify-between items-center text-slate-800 font-bold border-l-4 border-[#c97c1e]">
            <div class="flex items-center gap-2 overflow-hidden">
              <img src="icons/domain_black.svg" />
              <span class="font-extrabold text-slate-800 text-sm tracking-wide truncate">{{ payment.siteName }}</span>
            </div>
            <span
              class="text-[10px] font-extrabold px-2 py-0.5 bg-white/40 border border-white/20 text-slate-800 rounded-md shrink-0">
              {{ payment.feeTypeName }}
            </span>
          </div>

          <!-- Card Content -->
          <div class="p-4 space-y-3">
            <div class="flex justify-between items-center">
              <div>
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                  "ทะเบียน" : "License plate" }}</p>
                <p class="text-base font-extrabold text-slate-800 mt-0.5">{{ payment.lincense || '-' }}</p>
              </div>
              <div class="text-right">
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                  "ยอดชำระ" : "Total" }}</p>
                <p class="text-base font-extrabold text-[#c97c1e] mt-0.5">
                  {{ payment.total ?? 0 | number : "1.2-2" }}
                  <span class="text-xs font-normal text-slate-500">{{ currentLang === "TH" ? "บาท" : "Baht" }}</span>
                </p>
              </div>
            </div>

            <!-- Date & Time Info -->
            <div class="border-t border-dashed border-slate-100 pt-3 flex justify-between items-center text-xs">
              <div class="flex items-center gap-1.5 text-slate-500">
                <img src="icons/schedule_black.svg" class="w-6 h-6" />
                <span>{{ payment.paidDate | date : "dd/MM/yyyy HH:mm" }}</span>
              </div>
              <!-- Request status badge -->
              <span
                [ngClass]="payment.full_tax === '3' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : 'bg-slate-50 text-slate-500 border-slate-100'"
                class="text-[9px] font-extrabold px-2 py-0.5 rounded-full border">
                {{ payment.full_tax === '3' ? (currentLang === 'TH' ? 'ออกใบกำกับภาษีแล้ว' : 'Tax Invoice Issued') :
                (currentLang === 'TH' ? 'ยังไม่ขอใบกำกับภาษี' : 'No Tax Request') }}
              </span>
            </div>

            <!-- Advanced Expanded Details Section -->
            <div *ngIf="statusOpenDetails === payment.receiptId"
              class="mt-3 pt-3 border-t border-slate-100 space-y-2 animate-fade-in-up">
              <div class="grid grid-cols-2 gap-2 text-sm">
                <div class="bg-slate-50 p-2.5 rounded-xl border border-slate-100/40">
                  <p class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                    "เลขที่ใบเสร็จ" : "Receipt No." }}</p>
                  <p class="font-extrabold text-slate-700 text-xs mt-0.5 truncate">{{ payment.receiptId || '-' }}</p>
                </div>
                <div class="bg-slate-50 p-2.5 rounded-xl border border-slate-100/40">
                  <p class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                    "ค่าชำระ" : "Payment For" }}</p>
                  <p class="font-extrabold text-slate-700 text-xs mt-0.5 truncate">{{ payment.feeName || '-' }}</p>
                </div>
                <div class="bg-slate-50 p-2.5 rounded-xl border border-slate-100/40">
                  <p class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                    "ภาษีมูลค่าเพิ่ม (VAT)" : "VAT" }}</p>
                  <p class="font-extrabold text-slate-700 text-xs mt-0.5">{{ payment.vat ?? 0 | number : "1.2-2" }} ฿
                  </p>
                </div>
                <div class="bg-slate-50 p-2.5 rounded-xl border border-slate-100/40">
                  <p class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                    "ส่วนลด" : "Discount" }}</p>
                  <p class="font-extrabold text-slate-700 text-xs mt-0.5">{{ payment.discount ?? 0 | number : "1.2-2" }}
                    ฿</p>
                </div>
              </div>

              <!-- Elegant Actions -->
              <div class="flex gap-2 pt-2">
                <button (click)="openReceipt(payment)"
                  class="flex-1 bg-slate-50 hover:bg-slate-100 border border-slate-200 text-slate-700 text-xs font-extrabold py-2.5 rounded-xl transition-all flex items-center justify-center gap-1 active:scale-95">
                  <img src="icons/receipt_long_black.svg">
                  <span>{{ currentLang === "TH" ? "ดูใบเสร็จรับเงิน" : "View Receipt" }}</span>
                </button>
                <button (click)="openTaxFull(payment)" [disabled]="payment.full_tax === '3'"
                  [ngClass]="payment.full_tax === '3' ? 'bg-slate-100 text-slate-400 border-slate-200 opacity-60 cursor-not-allowed' : 'bg-gradient-to-r from-(--main-color) to-(--soft-color) text-slate-800 border-transparent shadow-sm'"
                  class="flex-1 text-xs font-extrabold py-2.5 rounded-xl border transition-all flex items-center justify-center gap-1 active:scale-95">
                  <img src="icons/domain_slate.svg">
                  <span>{{ currentLang === "TH" ? "ขอใบกำกับภาษี" : "Request Tax Invoice" }}</span>
                </button>
              </div>
            </div>

          </div>

          <!-- Bottom Expand Chevron Button -->
          <div (click)="openDetails(payment.receiptId)"
            class="bg-slate-50/50 py-2.5 flex justify-center items-center cursor-pointer hover:bg-slate-100/80 transition-colors border-t border-slate-100/50">
            <div [ngClass]="{'rotate-180': statusOpenDetails === payment.receiptId}"
              class="transition-transform duration-300">
              <img src="icons/expand_more_slate_dark.svg" />
            </div>

          </div>

          <!-- Elegant Empty State -->
          <div *ngIf="!isLoading && filteredPaymentHistory.length === 0"
            class="flex flex-col items-center justify-center py-16 px-4 bg-white rounded-2xl shadow-sm border border-slate-100 opacity-80 animate-fade-in">
            <div class="w-16 h-16 rounded-full bg-(--main-color)/10 flex items-center justify-center mb-3">
              <img src="icons/receipt_slate.svg" />
            </div>
            <p class="text-slate-700 font-bold text-sm text-center">
              {{ currentLang === "TH" ? "ไม่พบประวัติการชำระเงิน" : "No payment history found" }}
            </p>
            <p class="text-slate-400 text-xs mt-1 text-center">
              {{ currentLang === "TH"
              ? "ลองค้นหาด้วยวันหรือตัวกรองอื่นๆ เพิ่มเติม"
              : "Try shifting dates or modifying filters" }}
            </p>
          </div>

        </div>

      </div>
    </div>

  </div>

  <app-modal-template-2 *ngIf="showModal_option"
    [title]="currentLang === 'TH' ? 'คุณต้องการเลือกอะไร?' : 'What would you like to select?'"
    [leftButtonColor]="'bg-yellow-400'" [rightButtonColor]="'bg-green-600'" [disableRightButton]="disabledFulltax"
    [leftTextColor]="'text-yellow-900'" [rightTextColor]="'text-white'"
    [leftText]="currentLang === 'TH' ? 'ดูใบเสร็จรับเงิน' : 'View this Receipt.'"
    [rightText]="currentLang === 'TH' ? 'ขอใบกำกับภาษีเต็มรูป' : 'Request full tax invoice.'" (left)="clickToReceipt()"
    (right)="requestTaxFull()" (close)="closeModal_option()">
    <div class="w-[120px] h-[120px] mx-auto">
      <img src="icons/PSS/PSS Sticker-01.png" />
    </div>
    <div class="text-center text-gray-500">
      {{
      currentLang === 'TH'
      ? 'การขอใบกำกับภาษีเต็มรูปจะต้องขอในวันที่ที่ทำการชำระเงินเท่านั้น'
      : 'Requests for a full tax invoice must be made on the date of payment only.'
      }}
    </div>
  </app-modal-template-2>

  <!-- Modal Tax Invoice -->
  <div *ngIf="showTaxModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4">
    <div
      class="bg-white rounded-[2rem] w-full max-w-sm max-h-[85vh] overflow-y-auto px-6 pt-6 pb-8 shadow-2xl flex flex-col text-left animate-scale-up relative custom-scrollbar">

      <!-- Close Button -->
      <button (click)="closeTaxModal()"
        class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
        <img src="icons/close_slate_dark.svg" class="w-4 h-4" />
      </button>

      <!-- Modal Title -->
      <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
        {{ currentLang === "TH" ? "ขอใบกำกับภาษีแบบเต็มรูปย้อนหลัง" : "Request for a retrospective full tax invoice" }}
      </h2>

      <div class="space-y-3 flex-grow scroll-smooth">
        <!-- 1. Tax Type Segmented Control -->
        <div>
          <label class="block font-bold text-xs text-gray-600 mb-1.5">
            {{ currentLang === "TH" ? "ประเภทผู้เสียภาษี" : "Taxpayer Type" }}
          </label>
          <div class="bg-gray-200/60 p-1 rounded-2xl flex text-xs font-bold text-gray-500 select-none">
            <button type="button" (click)="selectedTaxType = '1'; filterAddressByTaxType()"
              class="flex-1 py-2 rounded-xl transition-all duration-300 text-center outline-none"
              [class.bg-white]="selectedTaxType === '1'" [class.text-gray-800]="selectedTaxType === '1'"
              [class.shadow-sm]="selectedTaxType === '1'">
              {{ currentLang === "TH" ? "บุคคลธรรมดา" : "Individual" }}
            </button>
            <button type="button" (click)="selectedTaxType = '2'; filterAddressByTaxType()"
              class="flex-1 py-2 rounded-xl transition-all duration-300 text-center outline-none"
              [class.bg-white]="selectedTaxType === '2'" [class.text-gray-800]="selectedTaxType === '2'"
              [class.shadow-sm]="selectedTaxType === '2'">
              {{ currentLang === "TH" ? "นิติบุคคล" : "Juristic" }}
            </button>
          </div>
        </div>

        <!-- 2. Select Saved Address Card -->
        <div *ngIf="showSelectAddress"
          class="bg-white rounded-2xl p-3 border border-gray-100 shadow-sm hover:border-amber-200 cursor-pointer flex justify-between items-start transition-all group"
          (click)="openAddressModal()">
          <div class="flex items-start gap-2.5">
            <div
              class="w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center text-amber-500 flex-shrink-0 group-hover:scale-105 transition-transform">
              <img src="icons/home_orange.svg" *ngIf="selectedTaxType === '1'" class="w-4 h-4" />
              <img src="icons/corporate_fare_orange.svg" *ngIf="selectedTaxType === '2'" class="w-4 h-4" />
            </div>
            <div class="flex flex-col text-xs text-gray-800">
              <div class="font-bold text-xs text-gray-900">
                {{ selectedAddress?.full_name }}
                <span class="text-gray-400 font-normal ml-1.5 text-[11px]">{{ selectedAddress?.phone }}</span>
              </div>
              <div class="mt-0.5 leading-snug text-[11px] text-gray-500 font-medium">
                <span *ngIf="selectedAddress?.company_name">{{ selectedAddress?.company_name }} </span>
                {{ selectedAddress?.address }} {{ selectedAddress?.sub_district }} {{ selectedAddress?.district }} {{
                selectedAddress?.provinces }} {{ selectedAddress?.zip_code }}
              </div>
            </div>
          </div>
          <img src="icons/expand_more_slate_dark.svg" class="-rotate-90 w-4 h-4 text-gray-400 mt-1" />
        </div>

        <!-- 3. Head Office Toggle -->
        <div *ngIf="selectedTaxType === '2'" class="flex items-center justify-between py-1.5 border-b border-gray-50">
          <span class="text-xs font-bold text-gray-700">{{ currentLang === "TH" ? "สำนักงานใหญ่" : "Head Office"
            }}</span>
          <label class="relative inline-flex items-center cursor-pointer select-none">
            <input type="checkbox" [(ngModel)]="mainOffice" class="sr-only peer" />
            <div class="w-10 h-5 bg-gray-200 rounded-full peer peer-checked:bg-amber-400 transition-colors"></div>
            <div
              class="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full transition peer-checked:translate-x-5 shadow-sm">
            </div>
          </label>
        </div>

        <!-- 4. Company / Taxpayer Name -->
        <div>
          <label class="block font-bold text-xs text-gray-600 mb-1.5">
            {{ currentLang === "TH" ? (selectedTaxType === '2' ? "ชื่อบริษัท / นิติบุคคล" : "ชื่อ-นามสกุล") :
            (selectedTaxType === '2' ? "Company Name" : "Full Name") }}
          </label>
          <input [(ngModel)]="taxName" type="text" [placeholder]="currentLang === 'TH' ? 'ระบุชื่อ' : 'Specify name'"
            class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
        </div>

        <!-- 5. Branch info if not head office -->
        <div *ngIf="!mainOffice && selectedTaxType === '2'" class="grid grid-cols-2 gap-2">
          <div>
            <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "ชื่อสาขา" : "Branch
              Name" }}</label>
            <input [(ngModel)]="branchName" type="text"
              [placeholder]="currentLang === 'TH' ? 'สาขาหลัก' : 'Specify branch'"
              class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
          </div>
          <div>
            <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "รหัสประจำสาขา" :
              "Branch Code" }}</label>
            <input [(ngModel)]="branchNo" type="text" [placeholder]="currentLang === 'TH' ? '00001' : '00001'"
              class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
          </div>
        </div>

        <!-- 6. Phone & Email -->
        <div class="grid grid-cols-2 gap-2">
          <div>
            <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "เบอร์โทรศัพท์" :
              "Phone Number" }}</label>
            <input [(ngModel)]="tax_phone" type="text" placeholder="0812345678" maxlength="10"
              class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
          </div>
          <div>
            <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "อีเมล" : "Email"
              }}</label>
            <input [(ngModel)]="email" type="email" placeholder="abc@example.com"
              class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
          </div>
        </div>

        <!-- 7. Tax ID -->
        <div>
          <label class="block font-bold text-xs text-gray-600 mb-1.5">
            {{ currentLang === "TH" ? "เลขประจำตัวผู้เสียภาษี" : "Tax ID" }}
          </label>
          <input [(ngModel)]="taxId" type="text" placeholder="1234567890123" maxlength="13"
            class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
        </div>

        <!-- 8. Address line -->
        <div>
          <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "ที่อยู่" : "Address
            Line" }}</label>
          <input [(ngModel)]="address" type="text"
            [placeholder]="currentLang === 'TH' ? 'ระบุบ้านเลขที่, ถนน, หมู่บ้าน' : 'Specify address'"
            class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
        </div>

        <!-- 9. Province, District, Subdistrict Custom Selects -->
        <div class="space-y-3">
          <!-- Province Custom Select -->
          <div class="relative">
            <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "จังหวัด" : "Province"
              }}</label>
            <div class="relative">
              <input type="text" [(ngModel)]="provinceSearchText" (focus)="openDropdown('province')"
                (blur)="closeDropdown('province')"
                [placeholder]="currentLang === 'TH' ? 'เลือกจังหวัด' : 'Select Province'"
                class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 cursor-pointer" />
              <img src="icons/expand_more_slate_dark.svg" [class.rotate-180]="activeDropdown === 'province'"
                class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none transition w-4 h-4" />
            </div>
            <div *ngIf="activeDropdown === 'province'" (mousedown)="$event.preventDefault()"
              class="absolute z-50 left-0 right-0 mt-1 max-h-40 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg custom-scrollbar py-1">
              <div *ngFor="let province of filteredProvincess" (click)="selectProvinceOption(province)"
                class="px-4 py-2 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
                {{ province.name_th }}
              </div>
              <div *ngIf="filteredProvincess.length === 0" class="px-4 py-2 text-xs text-gray-400 text-center">
                {{ currentLang === "TH" ? "ไม่พบข้อมูล" : "No matches found" }}
              </div>
            </div>
          </div>

          <!-- District Custom Select -->
          <div class="relative">
            <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "อำเภอ" : "District"
              }}</label>
            <div class="relative">
              <input type="text" [(ngModel)]="amphureSearchText" (focus)="openDropdown('amphure')"
                (blur)="closeDropdown('amphure')" [disabled]="!selectedProvinceId"
                [placeholder]="currentLang === 'TH' ? 'เลือกอำเภอ' : 'Select District'"
                class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 cursor-pointer disabled:opacity-50" />
              <img src="icons/expand_more_slate_dark.svg"
                [class.rotate-180]="activeDropdown === 'amphure' && selectedProvinceId"
                class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none transition w-4 h-4" />
            </div>
            <div *ngIf="activeDropdown === 'amphure' && selectedProvinceId" (mousedown)="$event.preventDefault()"
              class="absolute z-50 left-0 right-0 mt-1 max-h-40 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg custom-scrollbar py-1">
              <div *ngFor="let amphure of filteredAmphureOptions" (click)="selectAmphureOption(amphure)"
                class="px-4 py-2 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
                {{ amphure.name_th }}
              </div>
              <div *ngIf="filteredAmphureOptions.length === 0" class="px-4 py-2 text-xs text-gray-400 text-center">
                {{ currentLang === "TH" ? "ไม่พบข้อมูล" : "No matches found" }}
              </div>
            </div>
          </div>

          <!-- Subdistrict Custom Select -->
          <div class="relative">
            <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "ตำบล" : "Subdistrict"
              }}</label>
            <div class="relative">
              <input type="text" [(ngModel)]="tambonSearchText" (focus)="openDropdown('tambon')"
                (blur)="closeDropdown('tambon')" [disabled]="!selectedAmphureId"
                [placeholder]="currentLang === 'TH' ? 'เลือกตำบล' : 'Select Subdistrict'"
                class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 cursor-pointer disabled:opacity-50" />
              <img src="icons/expand_more_slate_dark.svg"
                [class.rotate-180]="activeDropdown === 'tambon' && selectedAmphureId"
                class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none transition w-4 h-4" />
            </div>
            <div *ngIf="activeDropdown === 'tambon' && selectedAmphureId" (mousedown)="$event.preventDefault()"
              class="absolute z-50 left-0 right-0 mt-1 max-h-40 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg custom-scrollbar py-1">
              <div *ngFor="let tambon of filteredTambonOptions" (click)="selectTambonOption(tambon)"
                class="px-4 py-2 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
                {{ tambon.name_th }}
              </div>
              <div *ngIf="filteredTambonOptions.length === 0" class="px-4 py-2 text-xs text-gray-400 text-center">
                {{ currentLang === "TH" ? "ไม่พบข้อมูล" : "No matches found" }}
              </div>
            </div>
          </div>

          <!-- Postal Code -->
          <div>
            <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "รหัสไปรษณีย์" :
              "Postal Code" }}</label>
            <input type="text" [(ngModel)]="zipcode" placeholder="10140" readonly
              class="w-full bg-gray-100 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-500 outline-none select-none" />
          </div>
        </div>
      </div>

      <!-- Action Button -->
      <button (click)="requestTax()"
        class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-xs font-bold rounded-xl py-3 shadow-[0_4px_12px_rgba(245,158,11,0.25)] transition-all duration-200 active:scale-95 outline-none mt-5 flex-shrink-0">
        {{ currentLang === "TH" ? "ขอใบกำกับภาษีเต็มรูป" : "Request full tax invoice" }}
      </button>
    </div>
  </div>

  <!-- Modal Confirmation -->
  <div *ngIf="showModal_confirm"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4">
    <div class="bg-white rounded-[2rem] w-full max-w-xs p-6 shadow-2xl text-center relative animate-scale-up">
      <button type="button" (click)="closeModal_Confirm()"
        class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
        <img src="icons/close_slate_dark.svg" class="w-4 h-4" />
      </button>

      <div class="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center text-amber-500 mx-auto mb-3">
        <img src="icons/info_slate_dark.svg" class="w-6 h-6" />
      </div>

      <h3 class="text-sm font-bold text-gray-800 mb-2">
        {{ currentLang === "TH" ? "คุณต้องการขอใบกำกับภาษีย้อนหลัง?" : "Request Retrospective Tax Invoice?" }}
      </h3>
      <p class="text-xs text-gray-500 leading-relaxed mb-5">
        {{ currentLang === "TH" ? "กรุณาตรวจสอบข้อมูลก่อนยืนยัน หากข้อมูลไม่ถูกต้องจะไม่สามารถแก้ไขได้ในภายหลัง" :
        "Please review the information carefully before confirming. Once submitted it cannot be modified." }}
      </p>

      <div class="flex flex-col gap-2">
        <button (click)="sendRequestFullTax()" type="button"
          class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-xs font-bold rounded-xl py-2.5 shadow-md active:scale-95 transition-all outline-none">
          {{ currentLang === "TH" ? "ตกลง" : "Confirm" }}
        </button>
        <button (click)="closeModal_Confirm()" type="button"
          class="w-full bg-gray-100 text-gray-600 text-xs font-bold rounded-xl py-2.5 hover:bg-gray-200 active:scale-95 transition-all outline-none">
          {{ currentLang === "TH" ? "ยกเลิก" : "Cancel" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isSaveLoading" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-2xl shadow-xl p-5 flex items-center gap-3 animate-scale-up">
      <svg class="animate-spin h-5 w-5 text-amber-500" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
      </svg>
      <span class="text-gray-800 font-bold text-xs">{{ currentLang === "TH" ? "กำลังบันทึกข้อมูล..." : "Saving..."
        }}</span>
    </div>
  </div>

  <!-- Modal Select Saved Address -->
  <div *ngIf="showAddressModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4">
    <div
      class="bg-white rounded-[2rem] w-full max-w-sm max-h-[80vh] overflow-y-auto p-6 shadow-2xl relative animate-scale-up custom-scrollbar flex flex-col">
      <button (click)="showAddressModal = false"
        class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
        <img src="icons/close_slate_dark.svg" class="w-4 h-4" />
      </button>
      <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">{{ currentLang === "TH" ? "เลือกที่อยู่" : "Select Address"
        }}</h2>

      <div class="space-y-2 flex-grow overflow-y-auto custom-scrollbar">
        <div *ngFor="let item of filteredAddressList"
          class="p-3 bg-white border border-gray-100 rounded-2xl cursor-pointer hover:border-amber-200 hover:bg-amber-50/10 transition-all text-xs text-gray-800 shadow-sm group"
          (click)="selectAddress(item)">
          <div
            class="font-bold text-xs text-gray-900 mb-1 group-hover:text-amber-600 transition-colors flex items-center justify-between">
            <span>{{ item.full_name }}</span>
            <span *ngIf="item.headquarters"
              class="inline-flex items-center gap-1 bg-green-50 text-green-600 text-[9px] font-bold px-2 py-0.5 rounded-full">
              {{ currentLang === "TH" ? "สำนักงานใหญ่" : "Head Office" }}
            </span>
          </div>
          <div class="text-[11px] text-gray-500 font-medium leading-relaxed">
            <span *ngIf="item.company_name" class="block font-semibold text-gray-700">{{ item.company_name }}</span>
            {{ item.address }} {{ item.sub_district }} {{ item.district }} {{ item.provinces }} {{ item.zip_code }}
          </div>
          <div *ngIf="item.email" class="text-[10px] text-gray-400 mt-1 flex items-center gap-1">
            <img src="icons/mail_slate.svg" class="w-3 h-3" />
            {{ item.email }}
          </div>
        </div>

        <div *ngIf="filteredAddressList.length === 0" class="py-8 text-center text-xs text-gray-400">
          {{ currentLang === "TH" ? "ไม่พบข้อมูลที่อยู่" : "No addresses found" }}
        </div>
      </div>
    </div>
  </div>

  <!-- Loading overlay at the very bottom outside the main container wrapper -->
  <app-pss-loading *ngIf="isLoading"></app-pss-loading>